export class SharingVendorIntegrationNotFoundError extends Error { }
